"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getQParameterByName = getQParameterByName;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _qs = _interopRequireDefault(require("qs"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function parseParams(str) {
  return str.replace('#', '').split('&').reduce(function (params, param) {
    var copypar = params;
    var paramSplit = param.split('=').map(function (value) {
      return decodeURIComponent(value.replace('+', ' '));
    });
    var param1 = paramSplit[1];
    copypar[paramSplit[0]] = param1;
    return copypar;
  }, {});
}
function getQParameterByName(name) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  var regex = new RegExp("[?&]".concat(name.replace(/[[\]]/g, '\\$&'), "(=([^&#]*)|&|#|$)"));
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
var Router = /*#__PURE__*/function () {
  function Router() {
    (0, _classCallCheck2.default)(this, Router);
  }
  return (0, _createClass2.default)(Router, null, [{
    key: "redirect",
    value: function redirect(pageName) {
      location.href = pageName;
    }
  }, {
    key: "setParamters",
    value: function setParamters(params) {
      var newHash = "#".concat(_qs.default.stringify(_objectSpread(_objectSpread({}, this.getAllParameters()), params)));
      if (history.pushState) {
        history.pushState(null, null, newHash);
      } else {
        location.hash = newHash;
      }
    }
  }, {
    key: "setParameter",
    value: function setParameter(param) {
      var params = this.getAllParameters();
      if (params === '') {
        this.setParamters(param);
      } else {
        params[Object.keys(param)[0]] = param[Object.keys(param)[0]];
        this.setParamters(params);
      }
      return true;
    }
  }, {
    key: "getParameter",
    value: function getParameter(name) {
      var params = window.location.hash ? parseParams(window.location.hash) : {};
      return params[name];
    }
  }, {
    key: "getAllParameters",
    value: function getAllParameters() {
      var params = window.location.hash !== '' ? _qs.default.parse(window.location.hash.split('#')[1]) : '';
      return params;
    }
  }, {
    key: "createUrl",
    value: function createUrl(uri, params) {
      if (params && Object.keys(params).length > 0) {
        var url = uri || '';
        return "".concat(url, "#").concat(_qs.default.stringify(params));
      }
      return uri;
    }
  }, {
    key: "encodeDataUrl",
    value: function encodeDataUrl(data) {
      return Object.keys(data).map(function (key) {
        return [key, data[key]].map(encodeURIComponent).join('=');
      }).join('&');
    }
  }, {
    key: "parseQueryParam",
    value: function parseQueryParam(paramString) {
      var returnObject = {};
      paramString.split('&').forEach(function (elem) {
        var fragments = elem.split('=');
        var fragment1 = fragments[1];
        returnObject[fragments[0]] = fragment1;
      });
      return returnObject;
    }
  }, {
    key: "getUrlParameter",
    value: function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1);
      var sURLVariables = sPageURL.split('&');
      var parameter = '';
      for (var i = 0; i < sURLVariables.length; i += 1) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
          var param1 = sParameterName[1];
          parameter = param1;
          return decodeURIComponent(sParameterName[1]);
        }
      }
      return parameter;
    }
  }]);
}();
var _default = exports.default = Router;